export default "__VITE_ASSET__B0ovrE5e__"